import { graphql } from '@newfront-insurance/graphql-frontend';

export const GENERATE_FILE_CONTENTS_URL = graphql(`
  mutation GenerateFileContentsUrl($input: GenerateFileContentsUrlInput!) {
    generateFileContentsUrl(input: $input) {
      downloadUrl
      fileName
      isEmailLogger
    }
  }
`);
